<app-bookmark-bar></app-bookmark-bar>
<div class="main__content mat-card modified_main_content">
  <ng-template content-host></ng-template>
</div>
